import {
  OPD_RETURNING_VISIT_GAP_DAYS,
  getDaysBetweenVisitDates,
} from "./patientPeriodSummary";

export const DEFAULT_OPD_CONSULTATION_WAIVER_DAYS =
  OPD_RETURNING_VISIT_GAP_DAYS;

export const DEFAULT_OPD_CONSULTATION_WAIVER_SETTINGS = {
  enabled: true,
  gapDays: DEFAULT_OPD_CONSULTATION_WAIVER_DAYS,
};

const parseBooleanFlag = (value, defaultValue = true) => {
  if (
    value === true ||
    value === "true" ||
    value === 1 ||
    value === "1"
  ) {
    return true;
  }

  if (
    value === false ||
    value === "false" ||
    value === 0 ||
    value === "0"
  ) {
    return false;
  }

  return defaultValue;
};

const parseGapDays = (value) => {
  const parsed = Number(value);

  if (!Number.isFinite(parsed) || parsed < 0) {
    return DEFAULT_OPD_CONSULTATION_WAIVER_DAYS;
  }

  return Math.floor(parsed);
};

export function parseOpdConsultationWaiverSettings(
  activeSubscription = null
) {
  if (
    !activeSubscription ||
    typeof activeSubscription !== "object"
  ) {
    return {
      ...DEFAULT_OPD_CONSULTATION_WAIVER_SETTINGS,
    };
  }

  // Supports both API response and internal settings object.
  const enabledRaw =
    activeSubscription.enabled ??
    activeSubscription.enableOpdConsultationWaiver ??
    activeSubscription.enable_opd_consultation_waiver ??
    activeSubscription.opdConsultationWaiverEnabled ??
    activeSubscription.opd_consultation_waiver_enabled;

  const daysRaw =
    activeSubscription.gapDays ??
    activeSubscription.opdConsultationWaiverDays ??
    activeSubscription.opd_consultation_waiver_days ??
    activeSubscription.opdReturningVisitGapDays ??
    activeSubscription.opd_returning_visit_gap_days;

  const hasEnabledConfig =
    enabledRaw !== undefined &&
    enabledRaw !== null &&
    enabledRaw !== "";

  const hasDaysConfig =
    daysRaw !== undefined &&
    daysRaw !== null &&
    daysRaw !== "";

  return {
    enabled: hasEnabledConfig
      ? parseBooleanFlag(enabledRaw, true)
      : DEFAULT_OPD_CONSULTATION_WAIVER_SETTINGS.enabled,

    gapDays: hasDaysConfig
      ? parseGapDays(daysRaw)
      : DEFAULT_OPD_CONSULTATION_WAIVER_SETTINGS.gapDays,
  };
}

export function requiresConsultationPaymentAfterVisitGap(
  anchorDate,
  settings = DEFAULT_OPD_CONSULTATION_WAIVER_SETTINGS
) {
  const { enabled, gapDays } =
    parseOpdConsultationWaiverSettings(settings);

  // Disabled => always require consultation payment.
  if (!enabled) {
    return true;
  }

  // No previous paid consultation found.
  if (!anchorDate) {
    return true;
  }

  const gap = getDaysBetweenVisitDates(
    anchorDate,
    new Date()
  );

  if (gap == null) {
    return true;
  }

  // Within configured days => ₹0.
  //
  // 15 days configured:
  // 0 ... 15 days => ₹0
  // >15 days       => consultation payment
  return gap > gapDays;
}

export function buildOpdConsultationWaiverPayload(
  settings = {}
) {
  const parsed =
    parseOpdConsultationWaiverSettings(settings);

  return {
    enableOpdConsultationWaiver: parsed.enabled,
    opdConsultationWaiverDays: parsed.enabled
      ? parsed.gapDays
      : null,
  };
}